
export const isDev = true;
export const isProd = true;

export const REACT_APP_LIFERAY_HOST = !isProd ? "https://preprod-dxpa.ansut.ci" : window?.Liferay?.ThemeDisplay?.getPortalURL();
export const REACT_APP_SCOPE_KEY = !isProd ? 39296 : window?.Liferay?.ThemeDisplay?.getScopeGroupId();
export const REACT_APP_BICICI_ORGANISATION_ID = isDev ? 505405 : 33906;

export const AUTHORIZATION_HEADER2 = !isProd ? "test_dsi@diginfactory.com:Digin@2025$" : "user@agrac.ci:Agrac@2024@";

export const VENTE_ENDPOINT = !isProd ? "/o/c/venteauxencheres" : "/o/c/venteauxenchereses";

export const VENTE_RELATION = !isProd ? "r_enchereParticipant_c_venteAuxEnchereId" : "r_enchereParticipant_c_venteAuxEncheresId";

export const VENTE_RELATION_ACCESS = !isProd ? "r_enchereParticipant_c_venteAuxEnchere" : "r_enchereParticipant_c_venteAuxEncheres";

export const LOGO_ACCESS_PROD = !isProd ? "documents/d/agrac-website/logo-agrac-blanc-inclub-20250220-174022-2-png" : "documents/d/guest/logo-agrac-blanc-inclub-20250220-174022-1-png";


/**
 * Code des diférentes liste
 */
export const INDENTIFIANT_RECUP_PROFESSION = !isProd ? '14482d24-3099-4ef4-a34d-f3455b6dc609' : '9f50c509-7e6a-5d9b-6ccc-41f8fc710aa1';
export const INDENTIFIANT_RECUP_GENRE = !isProd ? 'd2a21830-f35b-7875-b381-6536554f92c6' : 'f76b5fee-95b2-7083-6895-f8dcce3d34a0';
export const INDENTIFIANT_RECUP_PAYS = !isProd ? 'b4e819a3-8d9d-6108-f6ba-9626fce85f4e' : 'a187ff89-b42b-9654-5a15-10ca3bd6b09b';
export const INDENTIFIANT_RECUP_VILLE = !isProd ? '6206ff9c-c2dd-676b-22c2-22db06c791c0' : '8c6409ef-018c-fd76-4cd0-98b2cb071538';

export const API_HEADERS = isDev
  ? {
    "Content-Type": "application/json",
    Authorization: "Basic " + btoa(AUTHORIZATION_HEADER2),
  }
  : {
    "Content-Type": "application/json",
    Authorization: "Basic " + btoa(AUTHORIZATION_HEADER2),
  };

export const API_GUEST_HEADERS = {
  "Content-Type": "application/json",
};

export const API_FILES_HEADERS = isDev
  ? {
    Authorization: "Basic " + btoa(AUTHORIZATION_HEADER2),
    Accept: "application/json",
  }
  : {
    Accept: "application/json",
    Authorization: "Basic " + btoa(AUTHORIZATION_HEADER2),
  };


export const cf = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "XOF",
  minimumFractionDigits: 0,
});

export const formatDate = (date) => {
  return new Date(date).toLocaleString(
    "fr-FR",
    {
      timeZone: "UTC",
      month: "numeric",
      day: "numeric",
      year: "numeric"
    }
  )
}


// Fonction de tri générique
export function sortByLibelle(list) {
  return list.sort((a, b) => {
    // Convertir les noms en minuscules pour une comparaison insensible à la casse
    const nameA = a.libelle?.toLowerCase();
    const nameB = b.libelle?.toLowerCase();
    if (nameA < nameB) {
      return -1; // a vient avant b
    }
    if (nameA > nameB) {
      return 1; // a vient après b
    }
    return 0; // a et b sont égaux
  });
}


// Fonction de tri générique
export function sortByLabel(list) {
  return list.sort((a, b) => {
    // Convertir les noms en minuscules pour une comparaison insensible à la casse
    const nameA = a.label?.toLowerCase();
    const nameB = b.label?.toLowerCase();
    if (nameA < nameB) {
      return -1; // a vient avant b
    }
    if (nameA > nameB) {
      return 1; // a vient après b
    }
    return 0; // a et b sont égaux
  });
}



// Fonction de tri générique By Name
export function sortByName(tpiList) {
  return tpiList.sort((a, b) => {
    // Convertir les noms en minuscules pour une comparaison insensible à la casse
    const nameA = a.name?.toLowerCase();
    const nameB = b.name?.toLowerCase();
    if (nameA < nameB) {
      return -1; // a vient avant b
    }
    if (nameA > nameB) {
      return 1; // a vient après b
    }
    return 0; // a et b sont égaux
  });
}

export const fakeArrayProfessions = [
  { code: "AGRI", libelle: "Agriculteur / Agricultrice" },
  { code: "ELEVE", libelle: "Élève / Étudiant" },
  { code: "FONC", libelle: "Fonctionnaire" },
  { code: "ENSE", libelle: "Enseignant(e)" },
  { code: "INFIR", libelle: "Infirmier / Infirmière" },
  { code: "MEDEC", libelle: "Médecin" },
  { code: "CHAUF", libelle: "Chauffeur" },
  { code: "COMMC", libelle: "Commerçant(e)" },
  { code: "ENTRE", libelle: "Entrepreneur / Chef d’entreprise" },
  { code: "JOURN", libelle: "Journaliste" },
  { code: "JURIS", libelle: "Juriste / Avocat" },
  { code: "BANQ", libelle: "Banquier / Financier" },
  { code: "ETAT", libelle: "Agent de l'État" },
  { code: "OUVRI", libelle: "Ouvrier / Technicien" },
  { code: "ARTIS", libelle: "Artisan(e)" },
  { code: "INFOR", libelle: "Informaticien(ne)" },
  { code: "INGEN", libelle: "Ingénieur(e)" },
  { code: "ELEC", libelle: "Électricien(ne)" },
  { code: "MENU", libelle: "Menuisier(e)" },
  { code: "MACO", libelle: "Maçon(ne)" },
  { code: "COIF", libelle: "Coiffeur / Coiffeuse" },
  { code: "COUT", libelle: "Couturier / Couturière" },
  { code: "SEC", libelle: "Secrétaire / Assistant(e)" },
  { code: "COMPT", libelle: "Comptable" },
  { code: "GAR", libelle: "Garagiste / Mécanicien" },
  { code: "PHARM", libelle: "Pharmacien(ne)" },
  { code: "ETUD", libelle: "Étudiant(e)" },
  { code: "CHOME", libelle: "Sans emploi / Chômeur" },
  { code: "RET", libelle: "Retraité(e)" },
  { code: "SAL", libelle: "Salarié" },
  { code: "REL", libelle: "Religieux" },
  { code: "Autre", libelle: "Autre à préciser" }
];

// Liste des pays
export const paysOptions = [
  { code: "CI", libelle: "Côte d’Ivoire" },
  { code: "Autre", libelle: "Hors Côte d’Ivoire (à préciser)" },
];

// Liste des villes
export const villeOptions = [
  { code: "Abidjan", libelle: "Abidjan" },
  { code: "GrandAbidjan", libelle: "Grand Abidjan" },
  { code: "Autre", libelle: "Autre (à préciser)" },
];

export const capitalizeWords = (str) => {
  if (!str) return "";

  return str
    .toLowerCase()
    .trim()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const abidjanCommunesList = [
  { code: "abobo", libelle: "Abobo" },
  { code: "adjamé", libelle: "Adjamé" },
  { code: "anyama", libelle: "Anyama" },
  { code: "attécoubé", libelle: "Attécoubé" },
  { code: " Cocody", libelle: "Cocody" },
  { code: "koumassi", libelle: "Koumassi" },
  { code: "marcory", libelle: "Marcory" },
  { code: "plateau", libelle: "Plateau" },
  { code: "port-bouet", libelle: "Port-Bouet" },
  { code: "songon", libelle: "Songon" },
  { code: "treichville", libelle: "Treichville" },
  { code: "yopougon", libelle: "Yopougon" },
];


export const texteNb = "Cette fiche permettra au commissaire de vérifier votre identité et de validé votre participation à la vente aux enchères. Veuillez le conserver précieusement et le présenter à l'entrée de la salle de vente le jour de l'événement."


